module.exports = __webpack_public_path__ + "img/prizes.3f7d704c.png";